import { z } from 'zod';

import { BehaviorSettings } from './behavior-settings';

export const RichTextHeading = z.nullable(
  z.object({
    id: z.number(),
    uuid: z.string().nullable(),
    revisionId: z.number(),
    type: z.string(),
    status: z.boolean(),
    parentType: z.string(),
    behaviorSettings: z.optional(BehaviorSettings),
    body: z.string().nullable(),
  })
);

export type RichTextHeading = z.infer<typeof RichTextHeading>;
